export const label = {
  'nl-NL': 'Vorige',
  'zh-TW': '上一步',
  ar: 'السابق',
  az: 'Əvvəlki',
  be: 'Папярэдні',
  bg: 'Предишен',
  bs: 'Prethodni',
  cnr: 'Prethodno',
  cs: 'Předchozí',
  da: 'Forrige',
  de: 'Zurück',
  el: 'Προηγούμενο',
  en: 'Previous',
  es: 'Anterior',
  et: 'Eelmine',
  fi: 'Edellinen',
  fr: 'Précédent',
  he: 'הקודם',
  hr: 'Prethodni',
  hu: 'Előző',
  hy: 'Նախորդը',
  id: 'Sebelumnya',
  is: 'Fyrri',
  it: 'Precedente',
  ja: '前へ',
  ka: 'წინა',
  ko: '이전',
  lt: 'Ankstesnis',
  lv: 'Iepriekšējais',
  mk: 'Претходен',
  nl: 'Vorige',
  no: 'Forrige',
  pl: 'Poprzedni',
  pt: 'Anterior',
  ro: 'Anterior',
  ru: 'Предыдущий',
  sk: 'Predchádzajúci',
  sl: 'Prejšnji',
  sq: 'Paraprak',
  sr: 'Prethodni',
  sv: 'Föregående',
  th: 'ก่อนหน้า',
  tr: 'Önceki',
  uk: 'Попередній',
  vi: 'Trước đó',
  zh: '上一步',
};
